export default __webpack_public_path__ + "static/media/gvcDairy.b5e4be67.jpg";